export { TagComponent as default, Tag } from './Tag'
